import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import { Button, ButtonStyle, ConfirmModal, DetailCardSection, Modal } from "@prequel/shared-components";

import { useDeleteDataset } from "@/api/import/datasets";
import DangerZone from "@/components/DangerZone";
import { useDatasetContext } from "@/pages/import/DatasetsPage/DatasetPage";

const DatasetAdmin = () => {
  const navigate = useNavigate();
  const { dataset } = useDatasetContext();
  const deleteDataset = useDeleteDataset();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onConfirmDelete = () => {
    setShowDeleteModal(false);
    deleteDataset.mutate(dataset.id);
  };

  const dangerZoneActions = useMemo(
    () => [
      {
        label: "Delete dataset",
        description:
          "This action cannot be undone. All associated streams must be deleted before this dataset can be deleted.",
        buttonText: "Delete dataset",
        onClick: () => setShowDeleteModal(true),
      },
    ],
    [],
  );

  return (
    <>
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <ConfirmModal
          title="Delete dataset"
          message="Are you sure you want to delete this dataset? This action cannot be undone."
          onConfirm={onConfirmDelete}
          confirmButtonText="Delete"
          onCancel={() => setShowDeleteModal(false)}
        />
      </Modal>

      <DetailCardSection title="Edit dataset">
        <p className="mb-3 text-sm text-stone-600">
          Update the dataset&apos;s extract method, schedule, or key columns.
        </p>
        <Button
          text="Edit dataset"
          type={ButtonStyle.TERTIARY}
          onClick={() => navigate(`/import/datasets/${dataset.id}/edit`)}
        />
      </DetailCardSection>

      <DangerZone actions={dangerZoneActions} type="card" />
    </>
  );
};

export default DatasetAdmin;
